import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import LogoQualy from '../Components/LogoQualy';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { getAuth, signInWithEmailAndPassword, browserLocalPersistence, setPersistence, sendEmailVerification } from "firebase/auth";
import { useNavigate, useRevalidator } from 'react-router';
import { child, get, getDatabase, ref } from 'firebase/database';
import { checkUserAllowed } from '../Tools/tools';

export default function Login(props) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [loginErrorVisible, setLoginErrorVisible] = useState(false);
    const [loginButtonActive, setLoginButtonActive] = useState(false);
    const [invalidUserActive, setInvalidUserActive] = useState(false);

    const auth = getAuth(props.app);

    let navigate = useNavigate();

    const db = getDatabase()

    useEffect(() => {
        const timer = setTimeout(() => {
            if (auth.currentUser) {
                navigate('/');
            }

        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = (e) => {
        setFeedbackVisible(false);
        setLoginButtonActive(false);
        setLoginErrorVisible(false);
        setInvalidUserActive(false)

        e.preventDefault();

        setPersistence(auth, browserLocalPersistence).then(() => {
            return signInWithEmailAndPassword(auth, email, password).then(async (userCredential) => {
                setLoginButtonActive(true);

                const redirPath = window.localStorage.getItem('redirectPath')

                checkUserAllowed(userCredential.user.uid).then((allowed) => {
                    if (allowed) {
                        if (redirPath) {
                            window.localStorage.removeItem('redirectPath')
                            navigate(redirPath)
                        } else {
                            navigate('/');
                        }
                    } else {
                        setInvalidUserActive(true)
                        auth.signOut()
                    }
                })
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;

                setFeedbackVisible(true);
                setLoginButtonActive(true);
            });
        }).catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;

            setLoginErrorVisible(true);
        });
    };

    const resetPassword = (e) => {
        console.log('Reset Password');
        navigate('/trocar-senha')
    };

    return (
        <Container fluid
            className='d-flex justify-content-center align-items-center'
            style={{
                height: "100vh",
                background: `
                    linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
                    url("/static/images/login_bg.webp")
                `,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}>
            <Row className='justify-content-center w-100'>
                <Col md={3} className='bg-white p-5 rounded rounded-4'>
                    <LogoQualy className='w-100 d-flex justify-content-center mb-5' />
                    <h3 className="text-center">Login</h3>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicEmail" className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword" className="mb-3">
                            <Form.Label>Senha</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Senha"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <Form.Control.Feedback type="invalidPassword" className={'text-danger'} hidden={!feedbackVisible} >
                                E-mail ou senha incorretos.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback type="loginError" className={'text-danger'} hidden={!loginErrorVisible} >
                                Houve um problema durante o login. Tente novamente mais tarde.
                            </Form.Control.Feedback>
                            <Form.Control.Feedback type="invalidUser" className={'text-danger'} hidden={!invalidUserActive} >
                                Acesso bloqueado.
                            </Form.Control.Feedback>
                        </Form.Group>
                        <div className='d-flex justify-content-between align-items-end'>
                            <a onClick={(e) => resetPassword(e)} className='text-primary me-2' style={{ fontSize: '0.8em' }}>Esqueci minha senha</a>
                            <Button variant="primary" type="submit" className="w-25" active={!loginButtonActive}>
                                Login
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}
